module.exports = __webpack_public_path__ + "static/media/github.e715a765.svg";